export default "__VITE_ASSET__EDD10Awy__"